export default __webpack_public_path__ + "static/media/quality.7218235b.png";